import "./App.scss";
import LiveChat from "./livechat/pages/liveChat";
import Notification from "./notification";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
function App() {
  return (
    <div className="App">
      <Router>
          <Routes>
            <Route exact path="/:institute_id/livechat" element={<LiveChat />}></Route>
            <Route exact path="/notification" element={<Notification />}></Route>
          </Routes>
      </Router>
    </div>
  );
}

export default App;
